import { Spacing } from '@vkontakte/vkui';
import React from 'react';
import { Placeholder } from 'reactApp/ui/Placeholder/Placeholder';

import styles from './TariffCardLoader.css';

export const TariffCardLoader = () => (
    <div className={styles.root}>
        <Spacing size={52} />
        <div className={styles.quota}>
            <div className={styles.space}>
                <Placeholder />
            </div>
            <div className={styles.units}>
                <Placeholder />
            </div>
        </div>
        <Spacing size={26} />
        <div className={styles.informer}>
            <Placeholder />
        </div>

        <Spacing size={28} />

        {Array.from(new Array(4)).map((_, idx) => (
            <>
                <div className={styles.feature} key={idx}>
                    <Placeholder />
                </div>
                <Spacing size={16} />
            </>
        ))}

        <Spacing size={16} />

        <div className={styles.button}>
            <Placeholder />
        </div>
    </div>
);
